var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 80,
    viewBox: "0 0 288 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.844 7.25989L126.449 8.59326L73.0693 72.839L71.4645 71.5056L124.844 7.25989Z",
    fill: "#A729F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.408 7.8107C103.321 7.39344 101.165 7.1848 98.9747 7.1848C80.8584 7.1848 66.115 21.9282 66.115 40.0445C66.115 44.3563 66.9495 48.4942 68.4795 52.2843L63.5419 58.2304C60.7253 52.7711 59.1606 46.6165 59.1606 40.0793C59.1606 18.138 77.0335 0.265137 98.9747 0.265137C102.904 0.265137 106.729 0.85627 110.345 1.93421L105.408 7.8107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5421 72.2783C94.6284 72.6956 96.7843 72.9042 98.9749 72.9042C117.091 72.9042 131.835 58.1608 131.835 40.0445C131.835 35.7327 131 31.5949 129.47 27.8047L134.408 21.8586C137.224 27.3179 138.789 33.4726 138.789 40.0097C138.789 61.951 120.916 79.8239 98.9749 79.8239C95.0457 79.8239 91.2207 79.2327 87.6044 78.1548L92.5421 72.2783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8479 79.6152H0.117676V74.8167L46.7472 7.63681H0.117676V0.682373H58.8827V2.38621L10.0625 72.6608H58.8479V79.6152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.472 80.1366L246.757 2.76849L280.103 80.1366H287.684L253.364 0.508301H240.15L204.856 80.1366H212.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.556 0.334717V67.9318L145.813 12.5398V23.7712L190.356 80.1369H196.511V0.334717H189.556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287.77,
    height: 80,
    fill: "white",
    transform: "translate(0.115234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.30cbc0de9c5ab863495ed7d1bd9208ac.svg";
export { ForwardRef as ReactComponent };